import { UseInfiniteQueryResult } from 'react-query';
import { useInfiniteQueryBase } from '../../hooks';
import { fetchHealthInsurancePage } from './api';
import { USE_HEALTH_INSURANCE_QUERY_KEY } from './constants';
import { HealthInsuranceResponse } from './types';

export const useHealthInsuranceInfiniteQuery = (
  type: string | undefined
): UseInfiniteQueryResult<HealthInsuranceResponse> => {
  return useInfiniteQueryBase(
    [USE_HEALTH_INSURANCE_QUERY_KEY, type],
    pageParam =>
      fetchHealthInsurancePage(
        type,
        pageParam
      ) as Promise<HealthInsuranceResponse | null>,
    {
      enabled: !!type,
      entityName: 'health insurance'
    }
  );
};
